import { useEffect } from "react";
import { IFormSection, TSubmitType } from "../../types/common";
import {
  API_COMPOSITE_ITEMS,
  API_MERCHANTS_CONFIGURABLE,
  API_PAYMENT_ITEMS_CONFIGURABLE,
} from "../../utils/apis";

import { URL_COMPOSITE_ITEMS } from "../../utils/urls";
import useGet from "../common/useGet";
import { getResultOptions } from "../../utils/helpers";

export type TFormCustomProps = {
  id?: number;
  submitType?: TSubmitType;
};

export const useCompositeItemsForm = () => {
  const sections: IFormSection[] = [
    {
      title: "Composite Items",
      fields: [
        {
          field_name: "payment_item",
          type: "select",
          label: "Payment Item",
          props: { required: true },
          options_name: "payment_items",
        },

        {
          field_name: "secondary_payment_item",
          type: "select",
          label: " Secondary Payment Item",
          props: { required: true },
          options_data: [
            { id: "nwsc", name: "NWSC" },
            { id: "ura", name: "URA" },
          ],
        },
        {
          field_name: "merchant",
          type: "select",
          label: "Merchant",
          props: { required: true },
          options_name: "merchants",
        },
        {
          field_name: "minimum_amount",
          type: "number",
          label: "Minimum Amount",
          props: { required: true },
        },
      ],
    },
  ];

  const redirect = `${URL_COMPOSITE_ITEMS}`;

  const getConfigOptions = () => {
    const { loadData: getPaymentItems, data: paymentItems } = useGet();
    const { loadData: getMerchants, data: merchants } = useGet();

    // const getStaffOptions = (data: any) => {
    //   return data?.results?.length
    //     ? data.results.map((item: TUser) => ({
    //         id: item.id,
    //         name: stringifyName(item),
    //         data: item,
    //       }))
    //     : [];
    // };

    // useEffect(() => {
    //   getAllowanceTypes({
    //     api: "configurables/allowance-types/",
    //     params: {},
    //   });
    //   getStaff({
    //     api: API_USERS,
    //     params: {
    //       is_staff: true,
    //     },
    //   });
    // }, []);
    useEffect(() => {
      getPaymentItems({
        api: API_PAYMENT_ITEMS_CONFIGURABLE,
        params: {},
      });
      getMerchants({
        api: API_MERCHANTS_CONFIGURABLE,
        params: {},
      });
    }, []);
    return {
      merchants: getResultOptions(merchants, "name", "id"),
      payment_items: getResultOptions(paymentItems, "item_name", "paycode"),
    };
  };
  const options = {
    ...getConfigOptions(),
  };

  return { sections, redirect, options };
};

export function submitCompositeItems(payload: any, id: number | null) {
  //  on update
  if (id) {
    return {
      id,
      api: API_COMPOSITE_ITEMS,
      params: payload,
    };
  }
  // on create
  return {
    api: API_COMPOSITE_ITEMS,
    params: payload,
  };
}
